import React from 'react';
import { useIntl } from 'react-intl';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/pro-solid-svg-icons/faCheck';
import { TypedMemo } from '../../common/types';
import { assetShareMessages } from './assetShareMessages';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for the share page; each part uses its own slice of it */
import styles from './AssetShare.module.scss';
/* eslint-enable css-modules/no-unused-class */

/** "Link copied" after Copy link, or after Share in a browser with no share sheet (design asset-share c4). */
const AssetShareToastComponent: React.FC = () => {
  const intl = useIntl();
  return (
    <div className={styles.toast} role="status" data-testid="asset-share-copied">
      <FontAwesomeIcon icon={faCheck} className={styles.toastIcon} />
      {intl.formatMessage(assetShareMessages.linkCopied)}
    </div>
  );
};

export const AssetShareToast = TypedMemo(AssetShareToastComponent);
